import React from 'react';
import { useTheme } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import MicIcon from '@mui/icons-material/Mic';

const MemSection = () => {
  const theme = useTheme();

  return (
    <Box>
      <Box marginBottom={4}>
        <Typography
          sx={{ textTransform: 'uppercase', fontWeight: 'medium' }}
          gutterBottom
          color="primary"
          align="center"
        >
          Programa ancla
        </Typography>
        <Box
          component={Typography}
          fontWeight={700}
          variant="h4"
          gutterBottom
          align="center"
          color="primary"
        >
          En Producción con MEM (Host: María Eugenia Moreno)
        </Box>
        <Typography
          variant="body1"
          color="textSecondary"
          align="center"
          sx={{ maxWidth: 720, mx: 'auto', mb: 3 }}
        >
          El programa de María Eugenia es el espacio donde el Marketing y la Producción validan la marca.
        </Typography>
      </Box>
      <Box
        sx={{
          p: 3,
          borderRadius: 2,
          border: `1px solid ${theme.palette.divider}`,
          bgcolor: theme.palette.mode === 'dark' ? 'action.hover' : 'grey.50',
          maxWidth: 720,
          mx: 'auto',
        }}
      >
        <Box display="flex" justifyContent="center" marginBottom={2}>
          <MicIcon sx={{ fontSize: 48, color: theme.palette.primary.main }} />
        </Box>
        <Typography variant="h6" gutterBottom fontWeight={700}>
          Análisis de valor
        </Typography>
        <Typography variant="body2" color="textSecondary" paragraph>
          María Eugenia desglosa el éxito de los lanzamientos de Daka desde una óptica profesional, elevando la
          percepción de la marca.
        </Typography>
        <Typography variant="h6" gutterBottom fontWeight={700}>
          Entrevistas
        </Typography>
        <Typography variant="body2" color="textSecondary" paragraph>
          Espacios con voceros de Daka o invitados especiales para hablar de lanzamientos, tendencias y
          productos, dando visibilidad y autoridad a la marca en un contexto de conversación natural.
        </Typography>
        <Typography variant="h6" gutterBottom fontWeight={700}>
          Menciones de autor
        </Typography>
        <Typography variant="body2" color="textSecondary">
          Recomendaciones expertas en un contexto de tendencias, generando una confianza superior a la
          publicidad convencional.
        </Typography>
      </Box>
    </Box>
  );
};

export default MemSection;
